import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import LanguageDetector from 'i18next-browser-languagedetector'
import spanish from '@/locales/es-ES.json'
import english from '@/locales/en-US.json'

i18next
    .use(LanguageDetector)
    .init({
        legacy: false,
        locale: 'en',
        debug: true,
        fallbackLocale: 'en',
        fallbackLng: ["es-US", "en-US"],
        resources: {
            en: english,
            es: spanish
        }
    });

export default function (app) {
    app.use(I18NextVue, { i18next })
    return app
}